// extracted by mini-css-extract-plugin
export default {"skillGardenSection":"SkillGarden_skillGardenSection__RpqKG","skillGardenImage":"SkillGarden_skillGardenImage__p4ML8","skillGardenHeading":"SkillGarden_skillGardenHeading__EKeDF"};